import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  class: "coupon-received-title",
  role: "status"
}
const _hoisted_2 = { class: "coupon-received-list" }
const _hoisted_3 = {
  key: 1,
  class: "coupon-received-generic",
  "aria-label": "优惠券到账提醒"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("small", null, "专属礼遇", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "已存入当前账号，适用商品下单时自动比较优惠。", -1)
const _hoisted_6 = { class: "coupon-received-list" }

import {computed,nextTick,onBeforeUnmount,onMounted,ref,watch} from 'vue'
import {useRoute,useRouter} from 'vue-router'
import store from '@/store'
import customerRequest from '@/api/customer'
import request from '@/utils/request'
import ActivityCouponCard from '@/views/components/ActivityCouponCard.vue'
import {adminNoticeBlocking,couponReceiptBlocking} from '@/utils/adminNoticeRuntime'
import {couponReceiptIdentity,couponReceiptKey,couponReceiptSafePath,createCouponReceiptTracker,receiptActivity,ReceivedCoupon} from '@/utils/couponReceipt'

export default /*#__PURE__*/_defineComponent({
  __name: 'CouponReceivedNotice',
  props: {
    ready: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {ready:boolean};

const route=useRoute(),router=useRouter()
const visible=ref(false),notes=ref<ReceivedCoupon[]>([]),activity=ref<any>(null),tracker=createCouponReceiptTracker()
let serial=0,checking=false,disposed=false,poll:ReturnType<typeof setInterval>|undefined,timer:ReturnType<typeof setTimeout>|undefined
const identity=computed(()=>couponReceiptIdentity(props.ready,store.getters.token,store.getters.userInfo,store.getters.orgId,store.getters.orgInfo?.id))
const scope=()=>({orgId:Number(store.getters.orgId),customerId:Number(store.getters.userInfo?.id)})
const benefit=(note:ReceivedCoupon)=>Number(note.noteType)===5?`${note.discountRate ?? note.amount}折`:`￥${note.amount}`
const read=(key:string)=>localStorage.getItem(key)
function close(){visible.value=false;notes.value=[];activity.value=null;clearTimeout(timer);couponReceiptBlocking.value=false}
function invalidate(){serial++;checking=false;close()}
function safe(){
  return document.visibilityState!=='hidden' && !adminNoticeBlocking.value && couponReceiptSafePath(route.path)
    && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '')
    && !Array.from(document.querySelectorAll('.ant-modal-wrap:not(.client-coupon-received-shell), .ant-drawer-open')).some(el=>el.getClientRects().length>0 && getComputedStyle(el).visibility!=='hidden')
}
async function check(){
  if(disposed || checking || visible.value || !identity.value || !safe())return
  const current=++serial,who=identity.value,path=route.path,owner=scope()
  checking=true;couponReceiptBlocking.value=true
  const active=()=>!disposed && current===serial && who===identity.value && path===route.path && document.visibilityState!=='hidden'
  try{
    const [response,configuration]=await Promise.all([
      customerRequest.getMyValideNotesByCustomerId(owner.customerId),
      request({url:'fsystem/activityCoupon/campaigns',method:'GET',params:{orgId:owner.orgId}})
        .catch(()=>request({url:'fsystem/activityCoupon',method:'GET',params:{orgId:owner.orgId}}).catch(()=>null))
    ])
    if(!active() || !safe())return
    const incoming=tracker.unseen(response.data,owner,read)
    if(!incoming.length)return
    notes.value=incoming;activity.value=receiptActivity(configuration?.data,incoming,owner.orgId);visible.value=true
    await nextTick()
    if(!active() || !safe() || !tracker.remember(incoming,owner,read,(key,value)=>localStorage.setItem(key,value))){if(current===serial)close();return}
    timer=setTimeout(close,(activity.value?.popupSeconds || 8)*1000)
  }catch{/* 服务读取失败不误记已提醒，下轮仍可重试。 */}
  finally{if(current===serial){checking=false;if(!visible.value)couponReceiptBlocking.value=false}}
}
async function viewCoupons(){
  if(!identity.value)return
  const target=activity.value?.mode==='coupon'?{activityCouponId:String(activity.value.couponId),activityOrgId:String(scope().orgId)}:undefined
  close();await router.push({path:'/main/cuscenter/notes',query:target})
}
function visibility(){invalidate();if(document.visibilityState!=='hidden')void check()}
function storage(event:StorageEvent){
  const owner=scope(),prefix=couponReceiptKey(owner,0).replace(/0$/,'')
  if(event.key?.startsWith(prefix)){invalidate();void check()}
}
watch(identity,()=>{invalidate();void check()},{immediate:true})
watch(()=>route.path,()=>{invalidate();void check()})
watch(adminNoticeBlocking,blocked=>{if(blocked)invalidate();else void check()})
onMounted(()=>{
  document.addEventListener('visibilitychange',visibility);window.addEventListener('storage',storage)
  poll=setInterval(()=>void check(),15000)
})
onBeforeUnmount(()=>{disposed=true;invalidate();clearInterval(poll);document.removeEventListener('visibilitychange',visibility);window.removeEventListener('storage',storage)})

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: visible.value && !_unref(adminNoticeBlocking),
    footer: null,
    closable: false,
    "mask-closable": false,
    width: 286,
    centered: "",
    "wrap-class-name": "client-coupon-received-shell",
    "body-style": {padding:'0',background:'transparent'},
    onCancel: close
  }, {
    default: _withCtx(() => [
      (activity.value)
        ? (_openBlock(), _createBlock(ActivityCouponCard, {
            key: 0,
            config: activity.value,
            compact: "",
            onView: viewCoupons
          }, {
            before: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, "收到" + _toDisplayString(notes.value.length) + "张优惠券", 1)
            ]),
            after: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: note.customerNoteId
                  }, [
                    _createElementVNode("span", null, _toDisplayString(note.noteName || '优惠券'), 1),
                    _createElementVNode("b", null, _toDisplayString(benefit(note)), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["config"]))
        : (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h2", null, "收到" + _toDisplayString(notes.value.length) + "张优惠券", 1),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: note.customerNoteId
                }, [
                  _createElementVNode("span", null, _toDisplayString(note.noteName || '优惠券'), 1),
                  _createElementVNode("b", null, _toDisplayString(benefit(note)), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: viewCoupons
            }, "查看优惠券")
          ])),
      _createElementVNode("button", {
        class: "activity-close",
        type: "button",
        "aria-label": "关闭优惠券到账提醒",
        onClick: close
      }, "×")
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})